<script setup lang="ts">

withDefaults(defineProps<{
  selected: boolean
}>(), {
  selected: false
})

</script>

<template>
  <button :class="{
    'bg-slate-700 text-slate-300': selected,
    'bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-slate-300': !selected,
    'px-2 py-1 mr-1 rounded' : true,
  }"><slot></slot></button>
</template>

<style scoped lang="scss">

</style>